import React, {useContext, useState} from 'react'
import useTranslate from "../../../../modules/local/useTranslate";
import {LoginContext} from "../../../../components/LoginContext";
import {Tabs} from "antd";
import {IoFolderOpenOutline, IoHeartOutline} from "react-icons/io5";
import {MainViewItem} from "./MainViewItem";
import {LikedItems} from "./LikedItems";
import {CategoryItems} from "./CategoryItems";
import {DivineWordSvg} from "../../../../components/Svgs/DivineWordSvg";

export const GodWordsDialog = ({default_id}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const [currentTab, setCurrentTab] = useState('random_items')
    const [displayId, setDisplayId] = useState(default_id)

    const handleDisplayById = (id) => {
        setDisplayId(id);
        setCurrentTab("random_items");
    }

    return (
        <div className="flex flex-col gap-3 space-y-3">
            <Tabs
                activeKey={currentTab}
                style={{overflow: 'initial'}}
                tabBarStyle={{margin: '0 0 10px 0'}}
                onTabClick={(key, e) => {
                    setCurrentTab(key)
                }}
                items={[
                    {
                        id: 'random_items',
                        name: 'random_items',
                        icon: <DivineWordSvg size={14}/>,
                        title: t('god word today'),
                        children: (
                            <div className="flex flex-col gap-3">
                                <MainViewItem default_id={displayId}/>
                            </div>
                        ),
                    },
                    {
                        id: 'tagged_items',
                        name: 'tagged_items',
                        icon: <IoFolderOpenOutline size={14}/>,
                        title: t('topics'),
                        children: (
                            <div className="flex flex-col gap-3">
                                <CategoryItems {...{handleDisplayById}}/>
                            </div>
                        ),
                    },
                    {
                        id: 'bookmarked_items',
                        name: 'bookmarked_items',
                        icon: <IoHeartOutline size={14}/>,
                        title: t('bookmarked items'),
                        children: (
                            <div className="flex flex-col gap-3">
                                <LikedItems {...{handleDisplayById}}/>
                            </div>
                        ),
                    },
                ].map((e, i) => ({
                    key: e.id,
                    label: (
                        <span key={i} className="flex items-center gap-3">
              {e.icon}
                            <span>{t(e.title)}</span>
            </span>
                    ),
                    children: e.children,
                }))}
            />
        </div>
    )
}

